import { render, staticRenderFns } from "./BackDialog.vue?vue&type=template&id=7f70574b&scoped=true&"
import script from "./BackDialog.vue?vue&type=script&lang=ts&"
export * from "./BackDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BackDialog.vue?vue&type=style&index=0&id=7f70574b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f70574b",
  null
  
)

export default component.exports